import React from "react";
import { useTranslation } from "react-i18next";

export const HD611 = () => {
    const {t} = useTranslation()
    return(
        <>
        <div className="contentBox">
            <div className="tabBox">
                <div className="left">
                    <h3>
                        <span>HYUNDAI ENGINE:</span>
                        HD611 Series
                    </h3>
                    
                    <ul className="tabBtnBox">
                        <li className="active">{t("hyundai_8")}</li>
                        <li>{t("hyundai_9")}</li>
                    </ul>
                    {/* <!-- 탭 버튼 : 클릭시 active클래스 --> */}
                </div>
                <div className="right">
                    <div className="tabContentBox">
                        <div className="imgBox active">
                            <img src="/assets/images/hd611_view_img.png" alt="HD611 Series"/>
                        </div>
                        <div className="imgBox">
                            <img src="/assets/images/hd611_view_drawing.png" alt="HD611 Series"/>
                        </div>
                    </div>
                    {/* <!-- 탭버튼에 따라 이미지 변경 --> */}
                </div>
            </div>

            <div className="tableWrap ships">
                <table>
                    <thead>
                        <tr>
                            <th>{t("hyundai_10")}</th>
                            <th>{t("hyundai_11")}</th>
                            <th>HD611T</th>
                            <th>HD611TA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>{t("hyundai_12")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_13")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_14")}(BHP)</th>
                            <td>PS(kW)/RPM</td>
                            <td>260(191)/2,000</td>
                            <td>330(242)/2,100</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_15")}</th>
                            <td></td>
                            <td colSpan={2}>6</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_16")}</th>
                            <td>mm</td>
                            <td colSpan={2}>130x140</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_17")}</th>
                            <td>cc</td>
                            <td colSpan={2}>11,149</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_18")}</th>
                            <td></td>
                            <td>TC</td>
                            <td>TCI</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_19")}</th>
                            <td></td>
                            <td>16.0:1</td>
                            <td>16.5:1</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_20")}</th>
                            <td></td>
                            <td colSpan={2}>1-5-3-6-2-4</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_21")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_22")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_23")}</th>
                            <td>ℓ/hr</td>
                            <td>45.6</td>
                            <td>57.9</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_24")}</th>
                            <td>ℓ</td>
                            <td colSpan={2}>35</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_25")}</th>
                            <td>kg/㎠</td>
                            <td colSpan={2}>Idle : 1.5~3, Full : 3~5</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_26")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_27")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_28")}</th>
                            <td>V-KM</td>
                            <td colSpan={2}>24-5.5</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_29")}</th>
                            <td>V-A</td>
                            <td colSpan={2}>24-40</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_30")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_31")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_32")}</th>
                            <td>ℓ</td>
                            <td colSpan={2}>60</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_33")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_34")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_35")}</th>
                            <td></td>
                            <td colSpan={2}>{t("hyundai_36")}</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_37")}</th>
                            <td>mm</td>
                            <td colSpan={2}>1,849x901x1,142</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_38")}</th>
                            <td>kg</td>
                            <td>960</td>
                            <td>1,020</td>
                        </tr>
                        <tr>
                            <th>{t("hyundai_39")}</th>
                            <td></td>
                            <td>2.09, 2.42, 2.82, 3.19 (3.81)</td>
                            <td>1.97, 2.57, 3.08, 3.46 (4.04, 4.48)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </>
    )
}